import withHookForm from '../hoc/withHookForm';
import InputBox from './InputBox';

const InputBoxWithHookForm = withHookForm(InputBox);

export default InputBoxWithHookForm;
